module.exports = __webpack_public_path__ + "static/media/Wallet_trade.6f129cfc.svg";